<template>
  <div class="oauth-callback">
    <LoadingBounce></LoadingBounce>
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';
import Mobile from '@/mixins/Mobile';

export default {
  name: 'mobile-callback',

  mixins: [
    Mobile,
  ],

  methods: {
    ...mapActions([
      'setToken',
      'setDevice',
      'signIn',
      'fetchUserLicence',
      'fetchPremiumSchool',
      'fetchGrades',
      'fetchSubjects',
    ]),
  },

  computed: {
    ...mapGetters({
      routeQuery: 'getRouteQuery',
      currentUserLanguage: 'currentUserLanguage',
    }),
  },

  created() {
    const APP_NAME = 'classting';
    const continueUrl = this.routeQuery.continue_url;

    this.setDevice(APP_NAME);
    window.setToken = (token) => {
      this.setToken(token)
        .then(() => (
          this.signIn(token)
        ))
        .then(() => (
          Promise.all([
            this.fetchGrades(),
            this.fetchSubjects(),
            this.fetchUserLicence(),
            this.fetchPremiumSchool(),
          ])
        ))
        .then(() => {
          this.$i18n.locale = this.currentUserLanguage;
          return true;
        })
        .then(() => {
          if (continueUrl) {
            this.$router.replace(window.decodeURIComponent(continueUrl));
          } else {
            this.$router.replace('/');
          }

          return Promise.resolve();
        });
    };

    this.call('ctjscall://authorize?callback=setToken');
  },
};
</script>
